define('modules/editor/collections/form_collection',['require','exports','module','backbone','lodash','../../editor/models/elements/form','../../form_editor/collections/fields'],function(require, exports, module){
  "use strict";

  var Backbone = require("backbone"),
      _ = require("lodash");

  var Form = require("../../editor/models/elements/form"),
      FieldCollection = require("../../form_editor/collections/fields");

  var FormModel = Backbone.Model.extend({
    validate: function() {
      return !this.fields.reduce(function(isValid, field){
        return isValid || !!field.get("correodirectBinding");
      }, false);
    },
  });

  var FormCollection = Backbone.Collection.extend({
    model: FormModel,
    comparator: "step",
    addForm: function(form) {
      if (!form) return;
      // we need a model to hold the fields collection
      var index = form.getPropertyGroup("form:conversion").get("step");
      var model = new this.model({ step: index });
      model.fields = FieldCollection.fromJSON(form.fields);
      // var existingForm = this.at(index);
      // if (existingForm) form = this.merge(existingForm, form);
      //this.add(model, {at: index});
      this.add(model);
    },
    isValid: function() {
      this.validationError = [];
      var valid = this.reduce(function(isValid, model){
        return isValid || model.isValid();
      }, false);
      if (!valid) {
        this.validationError.push({ attribute: "fields"});
      }
      return valid;
    },
    getIntegrationData: function() {
      return this.reduce(function(data, form){
        return _.extend(data, form.getIntegrationData());
      }, {});
    }
    /*merge: function(existing, form) {
      form.fields.forEach(function(field){
        existing.fields.add(field, {merge: true});
      })
      return existing;
    },
    getAllFields: function() {
      return this.reduce(function(all, form){
        return all.concat(form.getIntegrableFields())
      }, [])
    }*/
  });

  module.exports = FormCollection;
});

